<header class="w-full h-40 flex flex-row px-4 pt-2 justify-around">
    <div class="flex flex-col justify-between w-[50%]">
        <div class="flex flex-col gap-1">
            <ngx-skeleton-loader count="1" [theme]="theme_bars(25)"></ngx-skeleton-loader>
            <ngx-skeleton-loader count="1" [theme]="theme_bars(70)"></ngx-skeleton-loader>
        </div>
        <div class="flex flex-col w-full">
            <ngx-skeleton-loader count="1" [theme]="theme_bars(25)"></ngx-skeleton-loader>
            <ngx-skeleton-loader class="w-full" count="1" [theme]="theme_bars(70)"></ngx-skeleton-loader>
        </div>
    </div>
    <div class="flex flex-col w-[50%]">
        <div class="">
            <ngx-skeleton-loader count="1" [theme]="theme_bars(15)"></ngx-skeleton-loader>
            <!-- <p class="italic">{{ 'ACTIONS' | translate }}</p> -->
            <div class="flex">
                <ngx-skeleton-loader appearance="circle" count="5" [theme]="theme_buttons"></ngx-skeleton-loader>
            </div>
        </div>
        <div class="flex flex-col w-full">
            <div class="h-9"></div>
            <ngx-skeleton-loader class="w-full" count="1" [theme]="theme_bars(70)"></ngx-skeleton-loader>
        </div>
    </div>
</header>